const A = '123456789ABCDEFGHJKLMNPQRSTUVWXYZabcdefghijkmnopqrstuvwxyz'.split('');
/**
 * Converts a Byte array to a hex string
 *
 * @param uint8arr Byte array
 * @returns Hex representation of the input array
 */
export function byteToHexString(uint8arr) {
    if (!uint8arr) {
        return '';
    }
    let hexStr = '';
    for (let i = 0; i < uint8arr.length; i++) {
        let hex = (uint8arr[i] & 0xff).toString(16);
        hex = (hex.length === 1) ? '0' + hex : hex;
        hexStr += hex;
    }
    return hexStr.toUpperCase();
}
/**
 * Converts a hex string to a Byte array
 *
 * @param str Hex representation of a series of bytes
 * @returns Converted Byte array
 */
export function hexStringToByte(str) {
    if (!str) {
        return new Uint8Array();
    }
    let a = [];
    for (let i = 0; i < str.length; i += 2) {
        a.push(parseInt(str.substring(i, i + 2), 16));
    }
    return new Uint8Array(a);
}
/**
 * Converts a Byte array to a B58 string
 *
 * @param B Byte array
 * @returns B58 representation of the input Byte array
 */
export function byteToB58(B) {
    let d = [];
    let s = '';
    let j;
    for (let i = 0; i < B.length; i++) {
        j = 0;
        let c = B[i];
        s += c || s.length ^ i ? '' : 1;
        while (j in d || c) {
            let n = d[j];
            n = n ? n * 256 + c : c;
            c = n / 58 | 0;
            d[j] = n % 58;
            j++;
        }
    }
    while (j--) {
        s += A[d[j]];
    }
    return s;
}
/**
 * Converts a B58 string to a Byte array
 *
 * @param S B58 representation of a Byte array
 * @returns Converted Byte array
 */
export function b58ToByte(S) {
    let d = [];
    let b = [];
    let j;
    for (let i = 0; i < S.length; i++) {
        j = 0;
        let c = A.indexOf(S[i]);
        if (c < 0) {
            return undefined;
        }
        if (!c && !(b.length ^ i)) {
            b.push(0);
        }
        while (j in d || c) {
            let n = d[j];
            n = n ? n * 58 + c : c;
            c = n >> 8;
            d[j] = n % 256;
            j++;
        }
    }
    while (j--) {
        b.push(d[j]);
    }
    return new Uint8Array(b);
}
